/* eslint-disable no-nested-ternary */
import React from 'react';
import { Box, Row, Column, Copy, Dropdown, useMediaQueries } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DownPaymentInput from '../PriceAndFinanceDetails/DownPaymentInput';
import DownPaymentTooltip from '../PriceAndFinanceDetails/DownPaymentTooltip';
import { useFinance } from '../SelectProductsContext/SelectProductsProvider';
import { DOWN_PAYMENT_KEY, DOWN_PAYMENT_ITEMS, TERM_BY_MONTH_KEY } from '../../utils/constants';

import themeStyles from './styles/PaymentSummary.styles';

const Container = themeStyles.apply(Box, 'Container');
const TableContainer = themeStyles.apply(Box, 'TableContainer');
const PaymentSummaryRow = themeStyles.apply(Row, 'PaymentSummaryRow');
const PaymentSummaryColumn = themeStyles.apply(Column, 'PaymentSummaryColumn');
const PaymentSummaryItems = themeStyles.apply(Copy, 'PaymentSummaryItems');
const Headline = themeStyles.apply(Row, 'Headline');

const PaymentSummaryUI = ({ paymentSummaryDetails }) => {
  const { t } = useTranslation();
  const [finance, setFinance] = useFinance();
  const { isMobile } = useMediaQueries();

  const renderPaymentSummaryValue = (item, hasSubItems) => {
    switch (item.key) {
      case DOWN_PAYMENT_KEY:
        return <DownPaymentInput isSummary />;
      case TERM_BY_MONTH_KEY:
        return (
          <Dropdown
            width="80px"
            defaultValue={finance.term}
            options={item.value}
            onChange={value => setFinance({ term: value })}
            name="termOptions"
            selectedValue={finance.term}
            dataTestId="cy-payment-summary-term-by-month"
            styling="secondary"
            ariaLabel={t('Sub-apps.PriceAndFinance.termByMonthLabel')}
          />
        );
      default:
        return (
          <PaymentSummaryItems hasSubItems={hasSubItems} data-testid="payment-summary-value">
            {item.value}
          </PaymentSummaryItems>
        );
    }
  };

  const mapSummaryItems = paymentSummaryDetails?.sort(
    (firstItem, secondItem) => firstItem.displayOrder - secondItem.displayOrder,
  );

  return (
    <Container data-testid="payment-summary-container">
      <Headline data-testid="cy-finance-label">{t('Sub-apps.PriceAndFinance.financeLabel')}</Headline>
      <TableContainer>
        {mapSummaryItems.map(item => {
          if (!item.label || item.value === undefined) return;
          const hasSubItems = item.key === 'dueUponDeliveryField' || item.key === 'downPaymentField';
          return item.key === DOWN_PAYMENT_KEY && isMobile ? (
            <PaymentSummaryRow key={item.label}>
              <PaymentSummaryColumn isMobileInput>
                <PaymentSummaryItems data-testid="payment-summary-name">
                  {item.label}
                  {DOWN_PAYMENT_ITEMS.includes(item.key) ? <DownPaymentTooltip /> : null}
                </PaymentSummaryItems>
                <DownPaymentInput />
              </PaymentSummaryColumn>
            </PaymentSummaryRow>
          ) : (
            <PaymentSummaryRow key={item.key}>
              <PaymentSummaryColumn width={[3 / 5, 3 / 5, 1 / 2]}>
                <PaymentSummaryItems hasSubItems={hasSubItems} data-testid="payment-summary-name">
                  {item.label}
                  {DOWN_PAYMENT_ITEMS.includes(item.key) ? <DownPaymentTooltip /> : null}
                </PaymentSummaryItems>
              </PaymentSummaryColumn>
              <PaymentSummaryColumn
                width={[2 / 5, 2 / 5, 1 / 2]}
                style={{ display: 'flex', justifyContent: 'flex-end', textAlign: 'right' }}
              >
                {renderPaymentSummaryValue(item, hasSubItems)}
              </PaymentSummaryColumn>
            </PaymentSummaryRow>
          );
        })}
      </TableContainer>
    </Container>
  );
};

PaymentSummaryUI.propTypes = {
  paymentSummaryDetails: PropTypes.arrayOf(PropTypes.shape({})),
};

export default PaymentSummaryUI;
